module.exports = __webpack_public_path__ + "assets/img/fuzhu.ef2aa729.png";